<template>
    <!-- Hero Section with decorative images -->
    <div class="relative px-4 md:px-8">
        <!-- Decorative elements - hidden on mobile, fade in on larger screens -->
        <div class="hidden lg:block">
            <img
                src="../../../../images/plus-left-plane.svg"
                alt=""
                class="absolute left-0 top-12 w-[280px] xl:w-[350px] pointer-events-none opacity-50 xl:opacity-100 transition-opacity"
            />
            <img
                src="../../../../images/plus-right-plane.svg"
                alt=""
                class="absolute right-0 top-24 w-[300px] xl:w-[380px] pointer-events-none opacity-50 xl:opacity-100 transition-opacity"
            />
            <img
                src="../../../../images/plus-ticket.svg"
                alt=""
                class="absolute left-[8%] xl:left-[15%] top-[280px] w-[70px] xl:w-[90px] rotate-[25deg] pointer-events-none opacity-40 xl:opacity-100 transition-opacity"
            />
            <img
                src="../../../../images/plus-suitcase.svg"
                alt=""
                class="absolute right-[5%] xl:right-[12%] top-8 w-[80px] xl:w-[100px] -rotate-12 pointer-events-none opacity-40 xl:opacity-100 transition-opacity"
            />
        </div>

        <div
            class="flex flex-col items-center pt-8 md:pt-16 pb-12 md:pb-20 relative z-10"
        >
            <img
                src="/images/plus-dashboard/travelplus-logo.svg"
                alt="10xTravel+"
                class="h-4"
            />
            <h1
                class="text-3xl md:text-5xl font-semibold text-slate-800 dark:text-slate-100 text-center mt-4 leading-tight max-w-2xl"
            >
                Stop leaving points (and money) on the table
            </h1>
            <p
                class="text-slate-500 dark:text-slate-400 text-base text-center mt-4 max-w-lg leading-relaxed"
            >
                10xTravel+ gives you real-time award alerts, benefit
                tracking, and expert access - so every point gets used,
                every credit gets claimed, and every trip costs less.
            </p>
            <p
                class="text-slate-500 dark:text-slate-400 text-base text-center mt-4 max-w-lg leading-relaxed"
            >
                All for
                <span class="text-orange">$10/month.</span>
                Less than most of the card benefits you're already
                forgetting to use.
            </p>
            <button
                class="mt-6 md:mt-8 bg-orange text-white text-sm font-medium py-2.5 px-4 rounded shadow-sm hover:bg-orange-dark transition-colors"
                type="button"
                @click="$emit('checkout')"
            >
                Join 10xTravel+
            </button>
        </div>
    </div>
</template>

<script setup>
defineEmits(['checkout']);
</script>
